import React from 'react'
import { ConfigProvider, Layout } from 'antd'
import Header from 'components/Header'
import Footer from 'components/Footer'

const PublicLayout = ({ children }) => {
  return (
    <Layout className='public-layout container' >
      <ConfigProvider>
        <Header />
        <div className='flex-1 bg-white' >
          {children}
        </div>
        <Footer />
      </ConfigProvider>
    </Layout>
  )
}

export default PublicLayout
